import React from 'react'
import type { ThemeContextType } from '@ztechapps/common.hook'
import { ThemeContext } from '@ztechapps/common.hook'
import { useColorMode } from '@ztechapps/common.hook'

export type ThemeProviderProps = { children: React.ReactNode } & ThemeContextType

export const ThemeProvider = ({ children, iconType = 'fa6i', routerType, ...props }: ThemeProviderProps) => {
  //we trigger the color mode initially here
  const colorMode = useColorMode({ initialize: true })

  return <ThemeContext.Provider value={{ iconType, routerType, colorMode, ...props }}>{children}</ThemeContext.Provider>
}
